/* jshint esversion: 6 */

import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

class WebsiteWidgetCloseForm extends React.Component {
  render() {
    return (
      <div id="hard-close-confirmation" className={this.props.className}>
        <div id="hard-close-confirmation-content">
          <span id="hard-close-confirmation-text">Are you sure you want to leave this conversation?</span>
          <div id="hard-close-no-button" onClick={this.props.onCancel}>No</div>
          <div id="hard-close-yes-button" onClick={this.props.onConfirm}>Yes</div>
        </div>
      </div>
    );
  }
}

WebsiteWidgetCloseForm.propTypes = {
  className: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default WebsiteWidgetCloseForm;
